import React from "react";

import { Button, Container } from "react-bootstrap";

import PressComponent from "@/components/mediaCoverage/Press.component";
import PressReleaseComponent from "@/components/mediaCoverage/PressRelease.component";
import TvComponent from "@/components/mediaCoverage/Tv.component";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const SECTION_IDS = {
  tv: "television",
  releases: "press-releases",
  press: "in-the-press",
} as const;

const scrollToSection = (id: string): void => {
  document.getElementById(id)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

const MediaCoverage = (): React.JSX.Element => {
  const { t } = i18n;

  const sections = [
    { id: SECTION_IDS.tv, label: t("Television") },
    { id: SECTION_IDS.releases, label: t("Press Releases") },
    { id: SECTION_IDS.press, label: t("In The Press") },
  ];

  return (
    <React.Fragment>
      <DocumentComponent title={t("media_coverage")} />

      <BannerComponent description="" title={t("media_coverage")} />

      <Container
        aria-label={t("media_coverage")}
        as="nav"
        className="d-flex justify-content-center flex-wrap gap-2 mb-5"
        style={{ marginTop: "-2rem" }}
      >
        {sections.map((section) => (
          <Button
            key={section.id}
            className="btn-outline"
            onClick={() => scrollToSection(section.id)}
            size="sm"
            variant="outline-success ps-4 pe-4"
          >
            {section.label}
          </Button>
        ))}
      </Container>

      <Container
        fluid
        as="section"
        className="mediaSection p-4 mb-4"
        id={SECTION_IDS.tv}
        style={{ backgroundColor: "var(--bg-light-color)" }}
      >
        <TvComponent />
      </Container>

      <section className="mediaSection" id={SECTION_IDS.releases}>
        <PressReleaseComponent />
      </section>

      <Container
        fluid
        as="section"
        className="mediaSection p-4 mb-4"
        id={SECTION_IDS.press}
        style={{ backgroundColor: "var(--bg-light-color)" }}
      >
        <PressComponent />
      </Container>

      <ScheduleComponent />

      <br />
      <br />
      <br />
    </React.Fragment>
  );
};

export default MediaCoverage;
